export const HOST = import.meta.env.VITE_API_HOST;
export const HOST_JOIN = import.meta.env.VITE_API_HOST_JOIN;
export const JOIN_URL = import.meta.env.VITE_JOIN_URL;

export const CLIENT = '/client';

export const OPEN = '/open';

export const DICT = `${OPEN}/dict`;
export const CITIES = `${OPEN}/cities`;
export const COUNTRIES = `${OPEN}/countries`;

export const CONTACT_US = `${CLIENT}/contact_us_form`;
export const INQUIRY = `${CLIENT}/inquiry_form`;

export const JOIN = '/join';
export const JOBS = `${JOIN}/jobs`;
export const JOBSEEKERS = `${JOIN}/landing/jobseekers`;

export const AUTH = '/auth';
export const CHECK_EMAIL = `${AUTH}/checkEmail`;
export const LOGIN = `${AUTH}/login`;
export const VERIFICATION_CODE = `${AUTH}/verification_code/send`;
export const POST_VERIFICATION_CODE = `${AUTH}/landing/link`;
